import { PageTable, Header } from '/src/layouts/page';
import capitalizeFirstLetter from '../../../../../utils/capitalizeFirstLetter';
import Table from '/src/components/table';
import '/src/components/UI/Button/IconButton/IconButton.css';
import getCutToken from "/src/utils/getCutToken";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import llmService from '../../services/llmService';
import Field from '/src/components/UI/Field/Field';
import Mixtral from '../../data/scenarios/mixtral.json'

function LlmTable() {
    const { getLlms } = llmService;

	const toast = useToastDispatchContext();
    const currentUser = JSON.parse(window.sessionStorage.getItem('user'));

    const cells = [
        {
            column: 'PROVIDER',
            name: 'provider',
            show: (value) => capitalizeFirstLetter(value) 
        },
        {
            column: 'NAME',
            name: 'model',
            sort: true,
            show: (value) => value
        },
        {
            column: 'STATUS',
            name: 'status',
            show: (value) => <div className="container_avaibility"><div className="circle_point available" style={{marginLeft : 24}}></div></div>
        }
    ];

    const filters = [
        { type: 'input', placeholder: 'provider', name: 'provider' },
        { type: 'input', placeholder: 'name', name: 'name' },
    ]

    const handleDownload = () => {
        const jsonString = JSON.stringify(Mixtral);
        const blob = new Blob([jsonString], { type: "application/json" });
        saveAs(blob, 'mistralai/Mixtral-8x7B-Instruct-v0.1.json');
    };
    
    return (
        <PageTable>
            <Header title="List Llms"></Header>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>
            <div className="warning_migrations_container" onClick={handleDownload} style={{cursor : 'pointer'}}>
                <Field listClassName="warning_migrations">✨ Test our llms directly in our bot by downloading an example with mixtral by clicking here</Field>
            </div>
            <Table name="Llm" cells={cells} api={getLlms} withPagination={false} filters={filters}></Table>

        </PageTable>
    );
}

export default LlmTable;